/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Requires_Mixdown_ShortInputs */

const en_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires Mixdown`)
};

const fr_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown requis`)
};

const de_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixdown erforderlich`)
};

const it_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiede Mixdown`)
};

const ru_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется сведение.`)
};

const es_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere mezcla`)
};

const zh_cn2_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要混音`)
};

const ja_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミックスダウンが必要`)
};

const hi_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिक्सडाउन आवश्यक है`)
};

const pt_pt2_audio_description_export_video_requires_mixdown_short = /** @type {(inputs: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requer Mixdown`)
};

/**
* | output |
* | --- |
* | "Requires Mixdown" |
*
* @param {Audio_Description_Export_Video_Requires_Mixdown_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_requires_mixdown_short = /** @type {((inputs?: Audio_Description_Export_Video_Requires_Mixdown_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Requires_Mixdown_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "de") return de_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "it") return it_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "ru") return ru_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "es") return es_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "ja") return ja_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "hi") return hi_audio_description_export_video_requires_mixdown_short(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_requires_mixdown_short(inputs)
	return en_audio_description_export_video_requires_mixdown_short(inputs)
});